
export enum ui {
    new = 0,
    old = 1
}
